export const changePassword = {
    "change_pwd_title": "Modifier le mot de passe",
    "change_pwd_old_password": "Mot de passe actuel",
    "change_pwd_new_password": "Nouveau mot de passe",
    "change_pwd_confirm_password": "Confirmer le mot de passe",
    "change_pwd_error": "Erreur lors de la modification du mot de passe"
}